import { Component, ElementRef, ViewChild, Input, OnChanges, SimpleChanges, HostListener, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ArvoreHierarquicaService } from '@core/services/arvore-hierarquica.service';

@Component({
  selector: 'app-arvore-list',
  templateUrl: './arvore-list.component.html',
  styleUrls: ['./arvore-list.component.scss']
})
export class ArvoreListComponent implements OnChanges, AfterViewInit {
  @ViewChild('panzoom') panzoomElement!: ElementRef;
  @ViewChild('container') containerElement!: ElementRef;
  @Input() entidade: any;
  hierarchyData: any;

  scale = 1;
  posX = 0;
  posY = 0;
  baseX = 0;
  baseY = 0;
  dragging = false;

  constructor(private service: ArvoreHierarquicaService, public route: ActivatedRoute) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.entidade) {
      this.carregarArvore();
    }
  }

  ngAfterViewInit(): void {
    this.adjustZoomToFit();
  }

  carregarArvore(): void {
    this.service.buscarArvoreHierarquica(this.entidade.id).subscribe((res: any) => {
      this.hierarchyData = res?.root;
      // console.log(this.hierarchyData);
      this.adjustZoomToFit();
    });
  }

  adjustZoomToFit(): void {
    setTimeout(() => {
      const content = this.panzoomElement.nativeElement;
      const container = this.containerElement.nativeElement;
      const scaleX = container.clientWidth / content.scrollWidth;
      const scaleY = container.clientHeight / content.scrollHeight;
      const scale = Math.min(scaleX, scaleY, 1);
      this.scale = scale * 0.9;
      this.posX = (container.clientWidth - content.scrollWidth * this.scale) / 2;
      this.posY = (container.clientHeight - content.scrollHeight * this.scale) / 2;
      this.updateTransform();
    });
  }

  zoomIn(): void {
    this.scale *= 1.1;
    this.updateTransform();
  }

  zoomOut(): void {
    this.scale /= 1.1;
    this.updateTransform();
  }

  resetTransform(): void {
    this.adjustZoomToFit();
  }

  private updateTransform(): void {
    this.panzoomElement.nativeElement.style.transform = `translate(${this.posX}px, ${this.posY}px) scale(${this.scale})`;
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent): void {
    this.dragging = true;
    this.baseX = event.clientX - this.posX;
    this.baseY = event.clientY - this.posY;
    event.preventDefault();
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent): void {
    if (this.dragging) {
      this.posX = event.clientX - this.baseX;
      this.posY = event.clientY - this.baseY;
      this.updateTransform();
    }
  }

  @HostListener('document:mouseup')
  onMouseUp(): void {
    this.dragging = false;
  }

  nomeRazaoSocial(node: any) {
    return node?.nomeRazaoSocial ?? null;
  }

  onChildExpand(expanded: boolean): void {
    this.resetTransform();
  }
}



